<template>
  <b-tabs v-model="activeTab" card end lazy nav-wrapper-class="sticky-navbar">
    <b-tab :title="tabs.status.name">
      <StatusTab
        :timeRange="timeRange"
        :urls="urls.statusUrls"
      ></StatusTab>
    </b-tab>
    <b-tab :title="tabs.processes.name">
      <ProcessesTab
        :timeRange="timeRange"
        :urls="urls.processCreationUrls"
      ></ProcessesTab>
    </b-tab>
    <b-tab :title="tabs.traffic.name">
      <TrafficTab
        :timeRange="timeRange"
        :urls="urls.networkConnectionUrls"
      ></TrafficTab>
    </b-tab>
    <b-tab :title="tabs.packages.name">
      <PackageTab
        :timeRange="timeRange"
        :url="urls.xtendPackageUrl"
      ></PackageTab>
    </b-tab>
    <b-tab :title="tabs.alerts.name">
      <AlertsTab
        :timeRange="timeRange"
        :shortTimeRange="shortTimeRange"
        :url="urls.xtendAlertsUrlPrefix"
      ></AlertsTab>
    </b-tab>
    <b-tab :title="tabs.probeMetrics.name">
      <ProbeMetricsTab
        :timeRange="timeRange"
        :shortTimeRange="shortTimeRange"
        :summaryUrl="urls.xtendProbeMetricsSummaryUrl"
        :tsUrl="urls.xtendProbeMetricsTsUrl"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import StatusTab from '@/xvisor/components/xtend/tabs/StatusTab.vue';
import ProcessesTab from '@/xvisor/components/xtend/tabs/ProcessesTab.vue';
import TrafficTab from '@/xvisor/components/xtend/tabs/TrafficTab.vue';
import AlertsTab from '@/xvisor/components/xtend/tabs/AlertsTab.vue';
import PackageTab from '@/xvisor/components/xtend/tabs/PackageTab.vue';
import ProbeMetricsTab from '@/xvisor/components/xtend/tabs/XtendProbeMetricsTab.vue';
import IssueTimeBarEventBus from '@/xvisor/bus/IssueTimeBarEventBus';

export default {
  components: {
    StatusTab,
    ProcessesTab,
    TrafficTab,
    AlertsTab,
    PackageTab,
    ProbeMetricsTab,
  },
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    shortTimeRange: {
      type: Object,
      required: true,
    },
    urls: {
      type: Object,
      required: true,
    },
    defaultAlertTab: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  created() {
    if (this.defaultAlertTab) {
      this.activeTab = 4;
    }
  },
  mounted() {
    IssueTimeBarEventBus.$on('alert-selected', this.switchToAlertsTab);
  },
  watch: {
    defaultAlertTab(newVal) {
      if (newVal) {
        this.activeTab = 4;
      }
    },
  },
  computed: {
    tabs() {
      return {
        status: { name: 'Status', index: 0 },
        processes: { name: 'Processes', index: 1 },
        traffic: { name: 'Traffic', index: 2 },
        packages: { name: 'Packages', index: 3 },
        alerts: { name: 'Alerts', index: 4 },
        probeMetrics: { name: 'Probes', index: 5 },
      };
    },
  },
  methods: {
    switchToAlertsTab() {
      this.activeTab = this.tabs.alerts.index;
    },
  },
  beforeDestroy() {
    IssueTimeBarEventBus.$off('alert-selected', this.switchToAlertsTab);
  },
};
</script>
